import { useState, useEffect } from 'react';
import api from '../../utils/api';
import { RefreshCw, AlertCircle, AlertTriangle, Info, Bug } from 'lucide-react';

const LEVELS = [
  { id: 'all', label: 'Tümü' },
  { id: 'error', label: 'Hatalar' },
];

const levelStyle = {
  error: { color: '#dc2626', bg: '#fef2f2', icon: AlertCircle },
  warn: { color: '#d97706', bg: '#fffbeb', icon: AlertTriangle },
  info: { color: '#2563eb', bg: '#eff6ff', icon: Info },
  debug: { color: '#64748b', bg: '#f8fafc', icon: Bug },
};

export default function SuperAdminLogs() {
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [level, setLevel] = useState('all');
  const [limit, setLimit] = useState(100);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  const load = async () => {
    setLoading(true);
    try {
      const data = await api.get(`/superadmin/logs?level=${level}&limit=${limit}`);
      setLogs(data.logs || []);
      setTotal(data.total || 0);
      setMessage(data.message || '');
    } catch {}
    setLoading(false);
  };

  useEffect(() => { load(); }, [level, limit]);

  return (
    <div style={{ padding: 28 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 700 }}>Sistem Logları</h1>
          <div style={{ fontSize: 13, color: '#64748b', marginTop: 2 }}>Bugünün logları · Toplam {total} satır</div>
        </div>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <select value={limit} onChange={e => setLimit(parseInt(e.target.value))} style={{ fontSize: 13, padding: '6px 10px' }}>
            <option value={50}>Son 50</option>
            <option value={100}>Son 100</option>
            <option value={250}>Son 250</option>
          </select>
          <button className="btn btn-secondary" onClick={load} disabled={loading}>
            <RefreshCw size={14} style={{ animation: loading ? 'spin 1s linear infinite' : 'none' }} /> Yenile
          </button>
        </div>
      </div>

      {/* Level Filtre */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 20, background: '#f1f5f9', borderRadius: 8, padding: 3, width: 'fit-content' }}>
        {LEVELS.map(l => (
          <button key={l.id} onClick={() => setLevel(l.id)} style={{
            padding: '6px 16px', border: 'none', borderRadius: 6, fontSize: 13, cursor: 'pointer',
            background: level === l.id ? 'white' : 'transparent',
            color: level === l.id ? '#1e293b' : '#64748b',
            fontWeight: level === l.id ? 600 : 400,
            boxShadow: level === l.id ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
          }}>{l.label}</button>
        ))}
      </div>

      {/* Log Listesi */}
      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        {loading ? (
          <div style={{ padding: 32, textAlign: 'center', color: '#94a3b8' }}>Yükleniyor...</div>
        ) : message ? (
          <div style={{ padding: 32, textAlign: 'center', color: '#94a3b8' }}>
            <Info size={32} color="#e2e8f0" style={{ margin: '0 auto 10px' }} />
            <div>{message}</div>
            <div style={{ fontSize: 12, marginTop: 6 }}>Backend'i başlatıp biraz bekleyin, loglar oluşmaya başlayacak</div>
          </div>
        ) : logs.length === 0 ? (
          <div style={{ padding: 32, textAlign: 'center', color: '#94a3b8' }}>Log bulunamadı</div>
        ) : (
          <div style={{ fontFamily: 'monospace', fontSize: 12 }}>
            {logs.map((log, i) => {
              const style = levelStyle[log.level] || levelStyle.info;
              const Icon = style.icon;
              return (
                <div key={i} style={{ display: 'flex', gap: 12, padding: '10px 16px', borderBottom: '1px solid #f1f5f9', background: i % 2 === 0 ? 'white' : '#fafafa', alignItems: 'flex-start' }}>
                  <div style={{ flexShrink: 0, paddingTop: 1 }}>
                    <Icon size={14} color={style.color} />
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', gap: 10, marginBottom: 3, flexWrap: 'wrap' }}>
                      <span style={{ fontSize: 11, padding: '1px 6px', borderRadius: 4, background: style.bg, color: style.color, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                        {log.level}
                      </span>
                      <span style={{ color: '#94a3b8', fontSize: 11 }}>{log.timestamp || ''}</span>
                    </div>
                    <div style={{ color: '#1e293b', wordBreak: 'break-all' }}>{log.message}</div>
                    {log.stack && (
                      <pre style={{ marginTop: 6, color: '#ef4444', fontSize: 11, whiteSpace: 'pre-wrap', background: '#fef2f2', padding: '6px 8px', borderRadius: 4, overflowX: 'auto' }}>
                        {log.stack}
                      </pre>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
